(() => {
  if (customElements.get('card-large-slider')) {
    return;
  }

  class CardLargeSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {
        waitForTransition: false,
        perPage: 1,
        pagination: true,
        gap: '2.4rem',
        breakpoints: {
          767: {
            arrows: true,
            pagination: false,
            gap: '1rem',
          }
        }
      };
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('.js-slider')) return;

      this.slider = new Splide(
        this.querySelector('.js-slider'),
        this.options
      ).mount();
    }
  }

  customElements.define('card-large-slider', CardLargeSlider);
})();
